import styled from "styled-components";

export const AddUserPageStyle = styled.div`
    .ant-row.ant-form-item {
        width: 260px;
    }
`;
